module.exports = __webpack_public_path__ + "img/bin.6d819336.svg";